<section class="mt-28 px-4">
  <div class="container mx-auto">
    <div
      class="w-full overflow-hidden bg-white rounded-2xl shadow-sm flex flex-wrap lg:flex-nowrap"
    >
      <!-- Text Side -->
      <div class="lg:w-1/2 p-8 md:p-16 lg:p-20 flex flex-col justify-center">
        <div
          class="inline-flex items-center gap-2 bg-amber-100 text-amber-700 text-sm font-semibold px-4 py-1.5 rounded-full w-fit mb-6"
        >
          <svg
            class="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
            />
          </svg>
          Value Added Services
        </div>
        <h2
          class="text-2xl lg:text-3xl font-bold text-gray-900 leading-tight mb-6"
        >
          We go the <span class="text-green-500">extra mile</span> for your business
        </h2>
        <ul class="space-y-4">
          <li class="flex items-start gap-3">
            <span
              class="flex-shrink-0 w-8 h-8 rounded-lg bg-green-100 flex items-center justify-center mt-0.5"
            >
              <svg
                class="w-4 h-4 text-green-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                />
              </svg>
            </span>
            <div>
              <p class="font-semibold text-gray-900">Google Business Profile</p>
              <p class="text-sm text-gray-500">
                Get found locally by customers near you
              </p>
            </div>
          </li>
          <li class="flex items-start gap-3">
            <span
              class="flex-shrink-0 w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center mt-0.5"
            >
              <svg
                class="w-4 h-4 text-blue-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </span>
            <div>
              <p class="font-semibold text-gray-900">Product Photography</p>
              <p class="text-sm text-gray-500">
                Professional photos for your products
              </p>
            </div>
          </li>
          <li class="flex items-start gap-3">
            <span
              class="flex-shrink-0 w-8 h-8 rounded-lg bg-purple-100 flex items-center justify-center mt-0.5"
            >
              <svg
                class="w-4 h-4 text-purple-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </span>
            <div>
              <p class="font-semibold text-gray-900">SEO & Google Indexing</p>
              <p class="text-sm text-gray-500">
                Rank higher and get more organic traffic
              </p>
            </div>
          </li>
          <li class="flex items-start gap-3">
            <span
              class="flex-shrink-0 w-8 h-8 rounded-lg bg-amber-100 flex items-center justify-center mt-0.5"
            >
              <svg
                class="w-4 h-4 text-amber-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
                />
              </svg>
            </span>
            <div>
              <p class="font-semibold text-gray-900">Blog & Content</p>
              <p class="text-sm text-gray-500">
                Articles and graphics to engage your audience
              </p>
            </div>
          </li>
        </ul>
        <div class="mt-8">
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSeSDVpw5ok9jzHCr2qBbEttWPaBSP0Mu7EUsM9xzB2JWNblGQ/viewform"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold px-8 py-3.5 rounded-full transition-all duration-200 shadow-md hover:shadow-lg"
          >
            Book Free Demo
            <svg
              class="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </a>
        </div>
      </div>
      <!-- Image Side -->
      <div
        class="lg:w-1/2 p-8 lg:p-14 bg-gradient-to-br from-amber-50 to-green-50 flex items-center justify-center"
      >
        <img
          src="/icons/Demo.svg"
          alt="Value Added Services"
          loading="lazy"
          class="max-h-80 object-contain"
        />
      </div>
    </div>
  </div>
</section>
